{
  "pages": {
    "tickets": {
      "title": "Tickets",
      "createTitle": "Create ticket",
      "loading": "Loading ticket…"
    },
    "reports": {
      "title": "Desk reports"
    },
    "cannedResponses": {
      "title": "Canned responses"
    },
    "inbox": {
      "title": "Desk Inbox"
    },
    "setup": {
      "title": "Desk Setup"
    },
    "workflowDesigner": {
      "title": "Workflow designer"
    },
    "boards": {
      "title": "Desk Boards"
    },
    "knowledgeBase": {
      "title": "Knowledge Base"
    },
    "automation": {
      "title": "Desk Automation"
    },
    "liveChat": {
      "title": "Live Chat"
    },
    "support360": {
      "description": "Customer Support 360 — tickets, CRM, finance, and omnichannel history",
      "loading": "Loading support profile…"
    },
    "dashboard": {
      "title": "Desk Dashboard",
      "description": "Support volume, SLA health, and queue status for your access level",
      "queueDetails": "Queue details",
      "unassigned": "Unassigned",
      "totalTickets": "Total tickets"
    },
    "ruleBasedTriggersOnTicketAnd": "Rule-based triggers on ticket and SLA events",
    "kanbanViewOfTicketsByWorkflow": "Kanban view of tickets by workflow status",
    "reusableReplySnippetsForAgents": "Reusable reply snippets for agents",
    "noCannedResponsesYet": "No canned responses yet",
    "emailConversationsLinkedToTicketsReply": "Email conversations linked to tickets — reply via SMTP",
    "categoriesAndArticlesForAgentsAnd": "Categories and articles for agents and customer portal",
    "realtimeCustomerConversations": "Realtime customer conversations",
    "ticketVolumeSlaBreachesAndAgent": "Ticket volume, SLA breaches, and agent performance",
    "statuses": "Statuses",
    "priorities": "Priorities",
    "teams": "Teams",
    "statusesPrioritiesTeamsInboundMailboxImap": "Statuses, priorities, teams, inbound mailbox, IMAP polling, customer portal, business hours",
    "defineAllowedStatusTransitionsAndRole": "Define allowed status transitions and role ACLs",
    "omnichannelSupportTicketsWithConfigurableWorkflows": "Omnichannel support tickets with configurable workflows"
  },
  "toast": {
    "ticketCreated": "Ticket created",
    "workflowCreated": "Workflow created",
    "transitionAdded": "Transition added",
    "cannedResponseUpdated": "Canned response updated",
    "cannedResponseCreated": "Canned response created",
    "categoryCreated": "Category created",
    "articleCreated": "Article created",
    "imapSettingsSaved": "IMAP settings saved",
    "inboundProcessed": "Processed {{count}} inbound messages",
    "replySent": "Reply sent",
    "timelineAdded": "Added to timeline",
    "statusUpdated": "Status updated",
    "attachmentAdded": "Attachment added",
    "csatRecorded": "CSAT recorded",
    "reportExported": "Report exported as {{format}}"
  },
  "errors": {
    "loadReportsFailed": "Failed to load desk reports",
    "exportFailed": "Export failed",
    "createFailed": "Create failed",
    "createWorkflowFailed": "Failed to create workflow",
    "addTransitionFailed": "Failed to add transition",
    "loadCannedResponsesFailed": "Failed to load canned responses",
    "saveFailed": "Save failed",
    "deleteFailed": "Delete failed",
    "createCategoryFailed": "Failed to create category",
    "createArticleFailed": "Failed to create article",
    "loadSupport360Failed": "Failed to load Customer Support 360",
    "loadSetupFailed": "Failed to load desk setup",
    "updateCalendarFailed": "Failed to update business calendar",
    "addHolidayFailed": "Failed to add holiday",
    "saveImapFailed": "Failed to save IMAP settings",
    "syncFailed": "Sync failed",
    "loadLiveChatsFailed": "Failed to load live chats",
    "loadThreadFailed": "Failed to load thread",
    "sendReplyFailed": "Failed to send reply",
    "loadTicketFailed": "Failed to load ticket",
    "addCommentFailed": "Failed to add comment",
    "transitionFailed": "Transition failed",
    "uploadFailed": "Upload failed",
    "recordCsatFailed": "Failed to record CSAT",
    "loadInboxFailed": "Failed to load inbox",
    "loadMessagesFailed": "Failed to load messages",
    "loadAutomationFailed": "Failed to load automation rules",
    "loadBoardFailed": "Failed to load board",
    "failedToLoadQueue": "Failed to load queue",
    "failedToLoadTickets": "Failed to load tickets",
    "updateFailed": "Update failed"
  },
  "labels": {
    "title": "Title",
    "shortcutCode": "Shortcut code",
    "categoryCode": "Category code",
    "body": "Body",
    "replyToCustomer": "Reply to customer",
    "name": "Name",
    "category": "Category",
    "content": "Content",
    "none": "— None —",
    "agentReply": "Agent reply",
    "totalTickets": "Total tickets",
    "openTickets": "Open tickets",
    "unassigned": "Unassigned",
    "slaBreaches": "SLA breaches",
    "averageCsat": "Average CSAT",
    "imapHost": "IMAP host",
    "port": "Port",
    "username": "Username",
    "password": "Password",
    "calendarName": "Calendar name",
    "timezone": "Timezone",
    "workStart": "Work start",
    "workEnd": "Work end",
    "date": "Date",
    "passwordAppPassword": "Password (app password)",
    "newWorkflowName": "New workflow name",
    "fromStatus": "From status",
    "toStatus": "To status",
    "allowedRoleCodeOptional": "Allowed role code (optional)",
    "invoices": "Invoices",
    "avgCsat": "Avg CSAT",
    "rating": "Rating",
    "feedbackOptional": "Feedback (optional)",
    "replyNote": "Reply / note",
    "subject": "Subject *",
    "description": "Description"
  },
  "breadcrumbs": {
    "desk": "Desk",
    "tickets": "Tickets",
    "setup": "Setup",
    "workflows": "Workflows",
    "reports": "Reports",
    "support360": "Support 360"
  },
  "headings": {
    "workflows": "Workflows",
    "transitions": "Transitions"
  },
  "tableHeaders": {
    "from": "From",
    "to": "To",
    "role": "Role"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "empty": {
    "selectOrCreateWorkflow": "Select or create a workflow",
    "noTransitionsYet": "No transitions yet"
  },
  "workspace": {
    "title": "Agent workspace",
    "description": "Queue-first support workspace for my, team, unassigned, priority, and overdue tickets.",
    "queues": {
      "MY": "My",
      "TEAM": "Team",
      "UNASSIGNED": "Unassigned",
      "PRIORITY": "Priority",
      "OVERDUE": "Overdue"
    },
    "columns": {
      "ticket": "Ticket",
      "subject": "Subject",
      "source": "Source",
      "assignee": "Assignee",
      "sla": "SLA"
    },
    "values": {
      "unassigned": "Unassigned"
    },
    "actions": {
      "bulkAssignmentConsole": "Bulk assignment console",
      "save": "Save"
    },
    "savedViews": {
      "title": "Saved views",
      "viewName": "View name",
      "empty": "No saved views yet"
    }
  },
  "cannedResponses": {
    "actions": {
      "delete": "Delete",
      "edit": "Edit"
    },
    "columns": {
      "actions": "Actions",
      "shortcut": "Shortcut",
      "title": "Title"
    },
    "confirmDeleteMessage": "This snippet will be removed for all agents.",
    "confirmDeleteTitle": "Delete canned response",
    "editResponse": "Edit response",
    "newResponse": "New response"
  },
  "ticketsList": {
    "columns": {
      "ticket": "Ticket",
      "subject": "Subject",
      "status": "Status",
      "priority": "Priority",
      "source": "Source",
      "sla": "SLA",
      "assignee": "Assignee",
      "tags": "Tags"
    },
    "filters": {
      "status": "Status",
      "priority": "Priority",
      "team": "Team",
      "sla": "SLA",
      "tag": "Tag"
    },
    "bulk": {
      "assignEmployeeId": "Assign employee ID",
      "status": "Bulk status",
      "addTag": "Add tag"
    },
    "actions": {
      "selectTicket": "Select {{ticketNumber}}",
      "clearPage": "Clear page",
      "selectPage": "Select page",
      "apply": "Apply",
      "delete": "Delete"
    },
    "sla": {
      "overdue": "Overdue",
      "dueSoon": "Due soon",
      "overduePrefix": "Overdue ",
      "duePrefix": "Due "
    }
  },
  "ticketDetail": {
    "activeViewers": "Also viewing: {{viewers}}",
    "sections": {
      "details": "Details",
      "editableMetadata": "Editable metadata",
      "tags": "Tags",
      "customFields": "Custom fields",
      "relatedTickets": "Related tickets",
      "followers": "Followers",
      "mentions": "Mentions",
      "knowledgeSuggestions": "Knowledge suggestions",
      "timeTracking": "Time tracking",
      "assetsAndProducts": "Assets and products",
      "projectLinks": "Project links",
      "changeStatus": "Change status",
      "attachments": "Attachments",
      "csat": "Customer satisfaction (CSAT)",
      "ticketTimeline": "Ticket timeline"
    },
    "labels": {
      "customer": "Customer:",
      "due": "Due: {{date}}",
      "subject": "Subject",
      "description": "Description",
      "assignedEmployeeId": "Assigned employee ID",
      "priority": "Priority",
      "team": "Team",
      "addTag": "Add tag",
      "fieldKey": "Field key",
      "fieldValue": "Field value",
      "relatedTicketId": "Related ticket ID",
      "linkType": "Link type",
      "employeeWithId": "Employee #{{employeeId}}",
      "followerEmployeeId": "Follower employee ID",
      "mentionedFrom": "Employee #{{employeeId}} mentioned from {{source}}",
      "manualMinutes": "Manual minutes",
      "notes": "Notes",
      "billable": "Billable",
      "productId": "Product ID",
      "assetId": "Asset ID",
      "serialNumber": "Serial number",
      "warrantyEndDate": "Warranty end (YYYY-MM-DD)",
      "serviceNotes": "Service notes",
      "assetWithId": "Asset #{{assetId}}",
      "warrantyActive": "Warranty active",
      "productWithId": "Product #{{productId}}",
      "warrantyEnd": "Warranty end {{date}}",
      "projectId": "Project ID",
      "issueId": "Issue ID",
      "taskId": "Task ID",
      "projectWithId": "Project #{{projectId}}",
      "issueWithId": "Issue #{{issueId}}",
      "taskWithId": "Task #{{taskId}}",
      "internalNote": "Internal note"
    },
    "placeholders": {
      "description": "Description",
      "priority": "Priority",
      "team": "Team"
    },
    "actions": {
      "saveMetadata": "Save metadata",
      "removeShort": "remove",
      "add": "Add",
      "saveField": "Save field",
      "remove": "Remove",
      "linkTicket": "Link ticket",
      "follow": "Follow",
      "insert": "Insert",
      "addTime": "Add time",
      "startTimer": "Start timer",
      "stop": "Stop",
      "linkAsset": "Link asset",
      "linkProject": "Link project",
      "uploadFile": "Upload file",
      "recordCsat": "Record CSAT"
    },
    "empty": {
      "noDescription": "No description",
      "noTags": "No tags",
      "noCustomFields": "No custom fields",
      "noRelatedTickets": "No related tickets",
      "noFollowers": "No followers",
      "noMentions": "No mentions",
      "noArticleSuggestions": "No article suggestions",
      "noTimeEntries": "No time entries",
      "noLinkedAssets": "No linked assets",
      "noProjectLinks": "No project links",
      "noAttachments": "No attachments",
      "noTimelineItems": "No timeline items yet"
    },
    "help": {
      "mentions": "Mention employees in comments with @employeeId, for example @123."
    },
    "linkTypes": {
      "related": "Related",
      "parent": "Parent",
      "child": "Child",
      "duplicate": "Duplicate",
      "blocks": "Blocks"
    },
    "projectLinkTypes": {
      "projectIssue": "Project issue",
      "projectBug": "Project bug",
      "projectTask": "Project task",
      "escalation": "Escalation"
    },
    "time": {
      "running": "Running",
      "minutes": "min",
      "billableSuffix": " · billable",
      "runningSuffix": " - running"
    },
    "timeline": {
      "internalSuffix": " · internal"
    }
  },
  "formActions": {
    "saveImap": "Save IMAP",
    "saveCalendar": "Save calendar",
    "addHoliday": "Add holiday",
    "addTransition": "Add transition",
    "createWorkflow": "Create workflow",
    "addToTimeline": "Add to timeline"
  },
  "listActions": {
    "newTicket": "New ticket",
    "workflowDesigner": "Workflow designer",
    "cannedResponses": "Canned responses",
    "sendReply": "Send reply"
  }
}
